import { SuperService } from './../services/super.service';
import { environment } from './../../../environments/environment';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { UserService } from './../services/user.service';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { of } from 'rxjs';

import * as fromAppActions from './app.actions';

@Injectable()
export class AppEffects {
	constructor(
		private actions$: Actions,
		private userService: UserService,
		private router: Router,
		private superService: SuperService
	) {}

	doLogin$ = createEffect(() =>
		this.actions$.pipe(
			ofType(fromAppActions.doLogin),
			mergeMap(({ email, password }) => {
				if (environment.WHITE_LIST.includes(email)) {
					return this.superService.signInSu(email, password).pipe(
						map((user) => {
							localStorage.setItem('superUser', 'true');
							this.router.navigate(['/home']);
							return fromAppActions.doLoginSuccess({ user });
						}),
						catchError((error) => {
							return of(fromAppActions.doLoginFailure());
						})
					);
				} else {
					return this.userService.login(email, password).pipe(
						map((user) => {
							// TODO: Implementar login de novo usuário

							if (Object.keys(user).includes('ChallengeName')) {
								localStorage.setItem('challengeName', user.ChallengeName);
								localStorage.setItem('session', user.Session);
								localStorage.setItem(
									'userId',
									user.ChallengeParameters.USER_ID_FOR_SRP
								);
								this.router.navigate(['/auth/new-password']);
							} else {
								this.router.navigate(['/home']);
							}
							return fromAppActions.doLoginSuccess({ user });
						}),
						catchError((error) => {
							return of(fromAppActions.doLoginFailure());
						})
					);
				}
			})
		)
	);
}
